import { useEffect, useState } from 'react';

import { ReactComponent as WarningIcon } from '../../../../icons/warning.svg';

import { Input } from '../../../common/input/Input';

export const TargetsStep = ({ goal, bodyStats, slots, targets, onTargetsChange, onSlotsChange, calculateTargets }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (targets) return;
    setLoading(true);
    setError(null);
    calculateTargets({ ...bodyStats, goal })
      .then((result) => onTargetsChange(result))
      .catch(() => setError('Could not calculate targets. Check your body stats.'))
      .finally(() => setLoading(false));
    // eslint-disable-next-line
  }, []);

  const setTarget = (key, value) => onTargetsChange({ ...targets, [key]: value === '' ? '' : +value });

  const setSlotPercent = (index, value) => {
    const next = [...slots];
    next[index] = { ...next[index], percent: value === '' ? '' : +value };
    onSlotsChange(next);
  };

  const percentSum = slots.reduce((sum, s) => sum + (Number(s.percent) || 0), 0);
  const percentValid = Math.abs(percentSum - 100) < 0.5;

  if (loading) {
    return (
      <div className="meal-planner-step">
        <h2 className="meal-planner-step__title">Calculating your targets…</h2>
      </div>
    );
  }

  if (error || !targets) {
    return (
      <div className="meal-planner-step">
        <h2 className="meal-planner-step__title">Something went wrong</h2>
        <p className="meal-planner-step__sub">{error}</p>
      </div>
    );
  }

  return (
    <div className="meal-planner-step">
      <h2 className="meal-planner-step__title">Your daily targets</h2>
      <p className="meal-planner-step__sub">Calculated from your goal and body stats - adjust if you want.</p>

      <div className="meal-planner-step__targets">
        <Input
          label="Calories (kcal)"
          type="number"
          name="calories"
          value={targets.calories ?? ''}
          onChange={({ value }) => setTarget('calories', value)}
        />
        <Input
          label="Protein (g)"
          type="number"
          name="protein"
          value={targets.protein ?? ''}
          onChange={({ value }) => setTarget('protein', value)}
        />
        <Input
          label="Carbs (g)"
          type="number"
          name="carbs"
          value={targets.carbs ?? ''}
          onChange={({ value }) => setTarget('carbs', value)}
        />
        <Input
          label="Fat (g)"
          type="number"
          name="fat"
          value={targets.fat ?? ''}
          onChange={({ value }) => setTarget('fat', value)}
        />
      </div>

      <h3 className="meal-planner-step__subtitle">Split across meals</h3>
      <div className="meal-planner-step__slot-split">
        {slots.map((slot, index) => (
          <div key={index} className="meal-planner-step__slot-split-row">
            <span>{slot.name}</span>
            <Input
              type="number"
              name={`slot-percent-${index}`}
              value={slot.percent ?? ''}
              onChange={({ value }) => setSlotPercent(index, value)}
              props={{ min: 0, max: 100 }}
            />
            <span>%</span>
          </div>
        ))}
      </div>
      <div className={`meal-planner-step__percent-total${percentValid ? '' : ' invalid'}`}>
        {!percentValid && <WarningIcon width={14} height={14} />}
        Total: {percentSum}% {percentValid ? '' : '(must add up to 100%)'}
      </div>
    </div>
  );
};
